module.exports = __webpack_public_path__ + "img/macaroni@2x.c548c7a1.png";